import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      createdAt: 1701115465920,
      object: 'otp',
      success: true,
      accessToken: '62efa65c-2e2d-4755-a9c0-3094690888aa',
      clientName: 'ישראל ישראלי',
      error: {
        code: 0,
        label: '',
        message: '',
      },
    },
    status: 200,
  },

  error: {
    response: {
      createdAt: 1701115461239,
      object: 'login',
      success: false,
    },
    status: 500,
  },
};

const otpHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(2000);
  return HttpResponse.json(response, status);
};

export {
  otpHandler,
};
